module.exports = __webpack_public_path__ + "media/images/icons/material/signal-c1d6a57846f84591a1986bbc77de9397.svg";